module.exports = __webpack_public_path__ + "static/img/fish38.e16aeee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish38.png
// module id = 9LSa
// module chunks = 0